import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { OrderVm } from './order.vm';

export class GetOrdersVm extends PageResponseVm<OrderVm, string> {
  @IsString()
  nextOffset: string;

  @Type(() => OrderVm)
  @ValidateNested({ each: true })
  objects: OrderVm[];
}
